<div class="wp-table-timeline--outer">
  <div class="wp-table-timeline--container">
    <wp-timeline-header></wp-timeline-header>
    <wp-timeline-static-elements></wp-timeline-static-elements>
    <wp-timeline-grid></wp-timeline-grid>
    <wp-timeline-relations></wp-timeline-relations>
    <div class="wp-table-timeline--body"></div>
  </div>
</div>
